
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/workouts/[slug]",
      function () {
        return require("private-next-pages/workouts/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/workouts/[slug]"])
      });
    }
  